import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';  // Import the burger icon from react-icons
import SocialIcons from '../common/SocialIcons';
import SearchBar from '../common/SearchBar';
import CartIcon from '../cart/CartIcon';
import MainMenu from './MainMenu';
import MobileMenu from './MobileMenu';
import logo from '../../logo.png';
import CartModal from '../cart/CartModal';
import { toast } from 'react-toastify';


const Header = styled.header`
  background-color: #ffffff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

const HeaderTop = styled.div`
  background-color: #f5f5f5;
  padding: 10px 0;
`;

const HeaderTopMessage = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  
  span {
    font-weight: bold;
    color: #28a745;
  }
`;

const HeaderBottom = styled.div`
  padding: 15px 0;
`;

const HeaderLogo = styled.div`
  img {
    max-height: 50px;
  }
`;

const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MobileMenuButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  margin-left: 15px;
  display: none;

  @media (max-width: 991px) {
    display: block;
  }
`;
const MainMenuWrapper = styled.div`
  background-color: #28a745;
`;

const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleCartModal = () => {
    setIsCartModalOpen(!isCartModalOpen);
  };

  const showToast = (message, type = 'success') => {
    toast[type](message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <Header>
      <HeaderTop>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 d-none d-lg-block">
              <SocialIcons />
            </div>
            <div className="col-12 col-lg-6 text-center text-lg-right">
              <HeaderTopMessage>
                <span>100% Halal</span> Fresh Meat Delivered to Your Doorstep
              </HeaderTopMessage>
            </div>
          </div>
        </div>
      </HeaderTop>

      <HeaderBottom>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 col-lg-3">
              <HeaderLogo>
                <Link to="/">
                  <img src={logo} alt="Site Logo" />
                </Link>
              </HeaderLogo>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <SearchBar />
            </div>
            <div className="col-6 col-lg-3">
              <HeaderButtons>
                <CartIcon onClick={toggleCartModal} />
                <MobileMenuButton onClick={toggleMobileMenu}>
                  <FaBars />  {/* Using the burger icon */}
                </MobileMenuButton>
              </HeaderButtons>
            </div>
          </div>
        </div>
      </HeaderBottom>

      <MainMenuWrapper className="d-none d-lg-block">
        <div className="container">
          <MenuContainer>
            <MainMenu />
          </MenuContainer>
        </div>
      </MainMenuWrapper>

      <MobileMenu isOpen={isMobileMenuOpen} onClose={toggleMobileMenu} />
      <CartModal isOpen={isCartModalOpen} onClose={toggleCartModal} showToast={showToast} />
    </Header>
  );
};

export default Navbar;